import { useContext } from "react";
import { MenuContext, MenuContextType } from ".";
import { BurgerSVG, CrossSVG } from "@/app/icons/svgs";

export default function Burger() {
  const menuContext = useContext(MenuContext);
  const { menuOpen, setMenuOpen } = menuContext as MenuContextType;
  return (
    <button
      className="flex justify-end mt-[0.75rem] w-[5.5rem] h-[5.5rem] absolute right-0 focus:outline-none focus-visible:ring focus-visible:ring-olive ring-inset z-20 group3:hidden"
      aria-label={menuOpen ? "Close Menu" : "Open Menu"}
      aria-expanded={menuOpen ? true : false}
      onClick={() => {
        setMenuOpen(!menuOpen);
      }}
    >
      {menuOpen ? <CrossSVG /> : <BurgerSVG />}
    </button>
  );
}
